<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" xl="7" lg="10" md="12" sm="10" >
        <v-card>
          <v-fade-transition>
            <v-overlay
              v-if="showOverlay"
              absolute
              color="#fff"
              :opacity="100">
              <v-progress-circular
                :size="100"
                :width="8"
                color="light-blue"
                indeterminate>
              </v-progress-circular>
            </v-overlay>
          </v-fade-transition>
          <div class="pa-2"
               style="background-color: #0091EA"/>

          <v-row align="start" justify="center" class="py-md-3 px-sm-5">
            <v-col cols="10" md="6" sm="6" class="pl-5">
              <v-row
                class="d-flex
                align-center
                justify-center
                justify-md-start
                justify-sm-start
                my-sm-4">
                <v-avatar size="100" class="elevation-3">
                  <v-img
                    :src="userInfo.url_logo || 'https://iauth.billpocket.com/img/icons/apple-touch-icon-152x152.png'"
                    :lazy-src="'https://iauth.billpocket.com/img/icons/apple-touch-icon-152x152.png'"
                    height="100"
                    alt="John"
                  />
                </v-avatar>
              </v-row>

              <v-row
                class="d-flex
                align-center
                justify-center
                justify-md-start
                justify-sm-start
                my-sm-2">
                <div>
                  <h1 class="font-weight-bold headline text-md-left text-sm-left text-center">
                    {{userInfo.nombre_comercial}}
                  </h1>
                  <p class="subtitle-2 mb-0 text-md-left text-sm-left text-center">
                    {{userInfo.description}}
                  </p>
                </div>
              </v-row>
             <!-- <v-row
                class="d-sm-none d-md-flex my-sm-2"
                align="center"
                justify="center">
                <div>
                  <h1 class="font-weight-bold title text-center">
                    {{userInfo.nombre_comercial}}
                  </h1>
                  <p class="subtitle-2 mb-0 text-center">
                    pay.billpocket.com/{{userInfo.slug}}
                  </p>
                </div>
              </v-row>-->
            </v-col>
            <v-col cols="10" md="6" sm="6">
              <div>
                <v-alert
                  v-if="reasonInvaliURl === 'expired'"
                  type="warning"
                  color="warning"
                  icon="warning"
                  outlined
                >
                  Este link se encuentra vencido,
                      contacta a {{ userInfo.nombre_comercial }}
                      para activarlo o crear uno nuevo.
                      Si lo prefieres también puedes enviarle
                      un monto abierto a través de su link de Pago a Distancia
                </v-alert>
                <v-alert
                  v-if="reasonInvaliURl === 'paid'"
                  type="warning"
                  color="warning"
                  icon="warning"
                  outlined
                >
                  Este link ya fue pagado,
                      contacta a {{ userInfo.nombre_comercial }}
                      para activarlo o crear uno nuevo.
                      Si lo prefieres también puedes enviarle
                      un monto abierto a través de su link de Pago a Distancia
                </v-alert>
                <p class="title font-weight-bold mb-8">
                  Información del Pago
                </p>
                <p class="subheading font-weight-bold mb-0">
                  Monto a enviar
                  <span class="font-weight-black">(MXN)</span>
                </p>
                <p class="caption mb-0">
                  Monto mínimo de $10
                </p>
                <VTextField
                  id="amount"
                  name="amount"
                  class="display-3 font-weight-regular"
                  height="60"
                  v-model="amount"
                  placeholder="0.00"
                  :color="color"
                  autocomplete="off"
                  prefix="$"
                  autofocus
                  clearable
                  @keyup="onlyForCurrency"
                  @focusout="formatting"
                  @click:clear="validateNextStep"
                />
              </div>
              <div class="mt-5">
                <p class="subheading font-weight-medium">
                  Mensaje
                  <span class="font-italic font-weight-light">(Opcional)</span>
                </p>
                <VTextField
                  id="message"
                  name="message"
                  class="font-regular"
                  placeholder="Incluye tu nombre o referencia"
                  :color="color"
                  v-model="message"
                  :counter="minMsgLenght"
                  :maxlength="minMsgLenght"
                  prepend-inner-icon="message"
                  autocomplete="off"
                  clearable
                />
              </div>
              <div class="mt-7">
                <VBtn
                  :disabled="btnDisable"
                  block color="blue-grey darken-3" class="white--text"
                  @click="generateCheckout">
                  {{btnMsg}}
                </VBtn>
              </div>
            </v-col>
          </v-row>

          <v-fade-transition>
            <v-progress-linear v-if="showProgressLinear"
                               indeterminate
                               height="10"
                               color="light-blue"
            ></v-progress-linear>
          </v-fade-transition>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="showError"
      color="error"
      :timeout="7000"
      :top="true"
    >
      {{ msgError }}
      <VBtn
        dark
        text
        @click="showError = false"
      >
        Cerrar
      </VBtn>
    </v-snackbar>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    color: 'light-blue accent-4',
    reasonInvaliURl: '',
    showOverlay: true,
    showProgressLinear: false,
    btnMsg: 'Ingresa el monto',
    btnDisable: true,
    btnColor: 'light-blue accent-4',
    amount: '',
    message: '',
    userInfo: {},
    slug: '',
    minMsgLenght: process.env.VUE_APP_MSG_MIN_LENGTH,
    msgError: '¡Ups! Sucedió un problema al generar tu pago, intenta de nuevo.',
    showError: false,
  }),
  beforeMount() {
    const { slug } = this.$route.params;
    this.slug = slug;
    this.reasonInvaliURl = this.$route.query.redirect;
    this.fetchAsyncUserData(slug)
      .then((data) => {
        this.showOverlay = false;
        const { receiver, description, rates } = data.response;
        this.userInfo = {
          id: receiver.id,
          nombre_comercial: receiver.nombre_comercial,
          email: receiver.email,
          url_logo: receiver.url_logo,
          slug,
          description,
          rates,
        };
        const titleMerchant = this.userInfo.nombre_comercial ? this.userInfo.nombre_comercial : '';
        window.document.title = `${titleMerchant} - Pago a distancia de Billpocket`;
      })
      .catch((error) => this.$router.push({ name: '404', params: { error } }));
  },
  methods: {
    fetchAsyncUserData: async (slug) => {
      const promiseData = await fetch(`${process.env.VUE_APP_FETCH_USER_DATA}/${slug}`);
      const response = await promiseData.json();
      const { status } = promiseData;
      if (status >= 400) {
        throw new Error(response.message);
      }
      return {
        response,
        status,
      };
    },
    postAsyncPaywith: async (payload) => {
      const promiseData = await fetch(`${process.env.VUE_APP_PAYWITH_SERVICE}`, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const response = await promiseData.json();
      const { status } = promiseData;
      if (status !== 201) {
        throw new Error('Problemas al continuar, intenta nuevamente.');
      }
      return {
        response,
        status,
      };
    },
    generateCheckout() {
      this.btnMsg = 'Espere un momento...';
      this.btnDisable = true;
      this.btnColor = 'light-blue lighten-4';
      this.showProgressLinear = true;
      const availablePaymentPlans = this.userInfo.rates ? this.userInfo.rates : [];
      const payload = {
        externalId: this.userInfo.nombre_comercial,
        items: [
          `${process.env.VUE_APP_DESCRIPTION_ITEM}`,
        ],
        total: parseFloat(this.amount.replace(/,/g, '')),
        description: this.message,
        real_user_id: this.userInfo.id,
        linkInformation: {
          usernameRemotePayment: this.slug,
          merchantDescription: this.userInfo.description,
        },
        rates: availablePaymentPlans,
      };
      this.postAsyncPaywith(payload)
        .then((data) => {
          const { checkoutId } = data.response;
          setTimeout(() => {
            window.location.href = `${process.env.VUE_APP_PAYWITH_APP}/${checkoutId}?username=${this.userInfo.slug}`;
          }, 500, checkoutId);
        })
        .catch(() => {
          this.showError = true;
          this.btnMsg = 'Intentar de nuevo';
          this.btnDisable = false;
          this.showProgressLinear = false;
        });
    },
    onlyForCurrency($event) {
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.amount.indexOf('.') !== -1)) { // 46 is dot
        $event.preventDefault();
      }
      // restrict to 2 decimal places
      /* if (this.amount != null && this.amount.indexOf('.') > -1
      && (this.amount.split('.')[1].length > 1)) {
        $event.preventDefault();
      } */

      const valueToCheck = (this.amount === null) ? '' : this.amount;
      this.amount = valueToCheck// Keep only digits and decimal points:
        // Keep only digits and decimal points:
        .replace(/[^\d.]/g, '')
        // Remove duplicated decimal point, if one exists:
        .replace(/^(\d*\.)(.*)\.(.*)$/, '$1$2$3')
        // Keep only two digits past the decimal point:
        .replace(/\.(\d{2})\d+/, '.$1')
        // Add thousands separators:
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      const amount = parseFloat(this.amount.replace(/,/g, ''));
      const stringAmount = amount.toString();
      if (Number.isNaN(amount)) {
        this.btnDisable = true;
        this.btnMsg = 'Ingresa el monto';
      } else if (parseInt(`${amount}`, 10) < 10) {
        this.btnDisable = true;
        this.btnMsg = 'Monto mínimo de $10';
      } else if (stringAmount.includes('.') && stringAmount.length > 11) {
        this.btnDisable = true;
        this.btnMsg = 'Monto máximo a 10 dígitos';
      } else if (!stringAmount.includes('.') && stringAmount.length > 10) {
        this.btnDisable = true;
        this.btnMsg = 'Monto máximo a 10 dígitos';
      } else {
        this.btnDisable = false;
        this.btnMsg = 'Siguiente';
      }
    },
    formatting() {
      if (this.amount === null) return;

      const number = parseFloat(this.amount.replace(/,/g, '')).toFixed(2);
      this.amount = number// Keep only digits and decimal points:
        // Keep only digits and decimal points:
        .replace(/[^\d.]/g, '')
        // Remove duplicated decimal point, if one exists:
        .replace(/^(\d*\.)(.*)\.(.*)$/, '$1$2$3')
        // Keep only two digits past the decimal point:
        .replace(/\.(\d{2})\d+/, '.$1')
        // Add thousands separators:
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    validateNextStep() {
      setTimeout(() => {
        this.btnDisable = true;
        this.btnMsg = 'Ingresa el monto';
      }, 10);
    },
  },
};
</script>
<style>

  #amount {
    max-height: 80px;
  }
  #amount::placeholder {
    line-height: 60px;
  }

  @media screen and (min-color-index:0) and(-webkit-min-device-pixel-ratio:0)
  { @media {
    #amount {
      max-height: 80px;
    }
    #amount::placeholder {
      padding-top: 1px;
      line-height: 70px;
    }
  }}

  .centered-input input {
    text-align: center
  }
</style>
